<div class="app-container" [class.is-mobile]="isMobile()">
  <app-header #header [userName]="authenticator.user ? authenticator.user.username : ''"
    [isMobile]="isMobile()" [showMenu]="true" [height]="headerHeight" [appLogo]="'/assets/logo.png'"
    [appName]="appName" (menuClickEvent)="sidebar.toggle()"
    (signInClickEvent)="$event ? signInAction() : signOutAction()"
    (rootCatalogClickEvent)="rootCatalog()"></app-header>
  <app-sidebar #sidebar [isMobile]="isMobile()" [headerHeight]="headerHeight">
    <router-outlet></router-outlet>
  </app-sidebar>
</div>